<template>
	<tbody class="analytics-step">
		<StepAnalyticsRow :step="step" @click="showPages=!showPages" :open="showPages" />

		<template v-if="showPages">
			<PageAnalyticsRow v-if="visiblePages.length > 1"
			                  :page="page" v-for="(page) in visiblePages"  />

			<template v-if="showHiddenPages && hiddenPages.length>0">
				<PageAnalyticsRow :page="page" v-for="(page) in hiddenPages"  />
			</template>

			<template v-if="hiddenPages.length>0">
				<PageAnalyticsRow :page="{page_id:0,name:'hidden'}" :showHiddenPages="showHiddenPages" @showMore="showHiddenPages=!showHiddenPages" />
			</template>
		</template>

	</tbody>
</template>

<script>
import StepAnalyticsRow from "@/views/funnels/funnel-plus/funnel/analytics/step_analytics_row";
import PageAnalyticsRow from "@/views/funnels/funnel-plus/funnel/analytics/page_analytics_row";
import VButton from "@/components/base/v-button";
export default {
	name: "analytics-step", components: {VButton, PageAnalyticsRow, StepAnalyticsRow}, props: ["step"],
	data(){
		return {
			showPages: false,
			showHiddenPages: false,
		}
	},
	computed:{
		hiddenPages() {
			return this.step.pages.filter(x => x.is_deleted)
		},
		visiblePages() {
			return this.step.pages.filter(x => !x.is_deleted)
		},
	},
	methods:{

	}
}
</script>

<style lang="scss" scoped>

</style>
